module.exports = __webpack_public_path__ + "img/Pic_LT_A.f0c8edf2.png";